import axios from 'axios'

import { successHandler, failHandler } from '@Root/utils/axiosHandler'

export const landAxios = axios.create({
  baseURL: '/api',
  timeout: 5000,
  headers: {
    authorization: `Bearer ${document.getElementById('token')?.dataset.token || ''}`,
  },
})

export const landBoardAxios = axios.create({
  baseURL: '/api',
  timeout: 60000,
  headers: {
    authorization: `Bearer ${document.getElementById('token')?.dataset.token || ''}`,
  },
})

export const landTaxAxios = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    authorization: `Bearer ${document.getElementById('token')?.dataset.token || ''}`,
  },
})

landAxios.interceptors.response.use(successHandler, failHandler)
landBoardAxios.interceptors.response.use(successHandler, failHandler)
landTaxAxios.interceptors.response.use(successHandler, failHandler)
